import { useEffect, useRef } from 'react';
import { factoryCookie, FactoryCookieProps } from 'helpers/common';

export function useDeepCompareMemo<T>(value: T) {
  const ref = useRef<T>(value);

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

function isEqual<T>(a: T, b: T) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export interface UseCookieProps extends FactoryCookieProps {
  active?: boolean | undefined;
}

export function useCookie(props: UseCookieProps) {
  useEffect(() => {
    if (props.active === false) return;

    factoryCookie(props);
  }, [props]);
}

export enum CookieType {
  String,
  Object,
}

export const pickProperties = <T>(
  object: T | undefined,
  objectProperties: (keyof T)[]
) => {
  if (object == null) return;

  return objectProperties.reduce((acc, property) => {
    if (object[property] != null) {
      acc = { ...acc, [property]: object[property] };
    }
    return acc;
  }, {} as Partial<T>);
};
